export default __webpack_public_path__ + "static/media/EliseEmmick.f24084f4.jpg";